PJQ.views.settings.UserTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'User-Type-Settings')
    },
    events: {
        'click .add-user-type': 'addClicked',
        'click .btn-edit-ut-perms': 'editPermissionsClicked',
        'click .btn-edit-user-type': 'editUserTypeClicked',
        'click .btn-delete-user-type': 'deleteUserTypeClicked',
        'click .btn-save-user-type': 'userTypeSave',
        'click .btn-cancel-edit-user-type': 'cancelEditUserType',
        'click .add-company-user-type': 'addCompanyClicked',
        'click .btn-edit-company-ut-perms': 'editCompanyPermissionsClicked',
        'click .btn-edit-company-user-type': 'editCompanyUserTypeClicked',
        'click .btn-delete-company-user-type': 'deleteCompanyUserTypeClicked',
        'click .btn-save-company-user-type': 'companyUserTypeSave',
        'click .btn-cancel-edit-company-user-type': 'cancelEditCompanyUserType',
        'click .btn-edit-company-user-type-notification-settings': 'companyNotificationSettingsClicked',
        'click .btn-edit-notification-settings': 'notificationSettingsClicked',
        'colorpickerCreate': 'createColorPickerBind',
        'colorpickerChange': 'setColorPickerValue',
    },
    beforeFirstRender: function () {
        this.options.enablePermissions = !PJQ.app.session.get('onAccount') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS);
        this.users = new PJQ.collections.users.Users();
        this.listenTo(this.users, 'sync', this.render);
        this.users.fetch();
    },
    afterRender: function () {
        this.companyDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".company-user-type-table"),
            isHideSearch: true,
            data: this.collection.getByIsCompany(true),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new User Type'
            },
            bSort: false,
            rowCallback: function (row, data) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Notifications',
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        isShown: _.bind(function () {
                            return this.options.enablePermissions;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return row.data().get('masterUserId') !== -1;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteUserType(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                                return '<input type="text" class="form-control input-user-type-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Company User Types",
                    "orderable": false
                },
                {
                    "data": "",
                    "title": "",
                    "width": "120px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            content = '<div class="input-group colorpicker-el"><input class="form-control input-block color-io"/><span class="input-group-append"><span id="color_picker" class="input-group colorpicker-element"><input type="hidden" class="form-control input-lg" name="color" value="#000000"><span class="input-group-text colorpicker-input-addon" data-original-title="" title="" tabIndex="0"><i style="background: #000000"></i></span></span></span></div>'
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this)
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": this.options.enablePermissions ? '160px' : '120px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '',
                            notificationButton = '<button type="button" title="Notifications" class="btn btn-share btn-edit-company-user-type-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-company-user-type wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-company-user-type wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            if (this.options.enablePermissions) {
                                buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-company-ut-perms mr-1"><span class="fal fa-key"></span></button>';
                                buttons += PJQ.app.session.hasPermission('users.canModifyNotifications') ? notificationButton : ``;
                            }
                            else{
                                buttons += notificationButton;
                            }
                            buttons += '<button type="button" class="btn btn-info btn-edit-company-user-type wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                            if (row.get('masterUserId') !== -1) {
                                buttons += '<button type="button" class="btn btn-danger btn-delete-company-user-type wd-30p"><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
        });

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".user-type-table"),
            isHideSearch: true,
            data: this.collection.getByIsCompany(false),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new User Type'
            },
            bSort: false,
            rowCallback: function (row, data, index) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Notifications',
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        isShown: _.bind(function () {
                            return this.options.enablePermissions;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return row.data().get('masterUserId') !== -1;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteCompanyUserType(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                                return '<input type="text" class="form-control input-user-type-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "User Types",
                    "orderable": false
                },
                {
                    "data": "",
                    "title": "",
                    "width": "120px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            content = '<div class="input-group colorpicker-el"><input class="form-control input-block color-io"/><span class="input-group-append"><span id="color_picker" class="input-group colorpicker-element"><input type="hidden" class="form-control input-lg" name="color" value="#000000"><span class="input-group-text colorpicker-input-addon" data-original-title="" title="" tabIndex="0"><i style="background: #000000"></i></span></span></span></div>'
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this)
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": this.options.enablePermissions ? '160px' : '120px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '',
                            notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-notification-settings mr-1"><span class="fal fa-bell"></span></button>'
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-user-type wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-user-type wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            if (this.options.enablePermissions) {
                                buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-ut-perms mr-1"><span class="fal fa-key"></span></button>';
                                buttons += PJQ.app.session.hasPermission('users.canModifyNotifications') ? notificationButton : ``
                            }
                            else{
                                buttons += notificationButton
                            }
                            buttons += '<button type="button" class="btn btn-info btn-edit-user-type wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                            if (row.get('masterUserId') !== -1) {
                                buttons += '<button type="button" class="btn btn-danger btn-delete-user-type wd-30p"><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>'
                    }, this)
                },
            ],
        });
    },
    createColorPickerBind: function(e) {
        let io = this.$('.color-io');

        io.val(e.color.string());

        io.on('change keyup', function () {
            e.colorpicker.setValue(io.val());
        });
    },
    setColorPickerValue: function(e) {
        let io = this.$('.color-io');

        if (e.value === io.val() || !e.color || !e.color.isValid()) {
            return;
        }

        io.val(e.color.string());
    },
    refreshDataTables: function () {
        this.dataTable.refresh();
        this.companyDataTable.refresh();
    },
    changeDefaultTypeAlert(returnCopy, callback) {
        this.dataTable.refresh();
        new PJQ.views.modals.YesNo({
            header: "Change User Types?",
            body: 'You are currently using the system default user types.  To edit a user type, we will need to create custom user types for your company.  This may take a minute, would you like to continue?',
            onYes: _.bind(function () {
                this.copyUserTypes(returnCopy, _.bind(function (userTypes, newUserType) {
                    callback(userTypes, newUserType);
                    this.refreshDataTables();
                }, this));
            }, this)
        });
    },
    copyUserTypes: function (returnCopy, callback) {
        this.collection.copy(_.bind(function () {
            let newUt = null;
            if (returnCopy != null) {
                let returnName = returnCopy.get('name');
                newUt = _.find(this.collection.models, function (u) {
                    return u.get('name') === returnName;
                });
            }
            callback(this.collection.models, newUt);
        }, this));
    },
    addClicked: function () {
        let fnAdd = _.bind(function () {
            let newUserType = new PJQ.models.userTypes.UserType({
                name: "",
                color: '#000000',
                sortOrder: this.collection.length + 1,
                isCompanyUser: false
            });
            this.collection.add(newUserType);
            this.dataTable.addRow(newUserType);
            this.userTypeContext = newUserType;
            this.defaultColor = this.userTypeContext.get('color');
            this.userTypeColor = this.userTypeContext.attributes.color;
            this.dataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: this.userTypeColor,
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', this.userTypeContext.get('color'));
        }, this);
        if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(null, function () {
                fnAdd();
            });
        } else {
            fnAdd();
        }
    },
    addCompanyClicked: function () {
        let fnAdd = _.bind(function () {
            let newUserType = new PJQ.models.userTypes.UserType({
                name: "",
                color: '#000000',
                sortOrder: this.collection.length + 1,
                isCompanyUser: true
            });
            this.collection.add(newUserType);
            this.companyDataTable.addRow(newUserType);
            this.userTypeContext = newUserType;
            this.defaultColor = this.userTypeContext.get('color');
            this.userTypeColor = this.userTypeContext.attributes.color;
            this.companyDataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: this.userTypeColor,
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', this.userTypeContext.get('color'));
        }, this);
        if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(null, function () {
                fnAdd();
            });
        } else {
            fnAdd();
        }
    },
    companyNotificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            userType = this.companyDataTable.getRow(target.closest('tr')).data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.notificationSettings(newUserType);
            });
        } else {
            this.notificationSettings(userType);
        }
    },
    notificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            userType = this.dataTable.getRow(target.closest('tr')).data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.notificationSettings(newUserType);
            });
        } else {
            this.notificationSettings(userType);
        }
    },
    notificationSettings: function (userType) {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: userType
        });
    },
    editCompanyPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.companyDataTable.getRow(target.closest('tr')),
            userType = row.data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.editPermissions(newUserType);
            });
        } else {
            this.editPermissions(userType);
        }
    },
    editPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            userType = row.data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.editPermissions(newUserType);
            });
        } else {
            this.editPermissions(userType);
        }
    },
    editPermissions: function (userType) {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: userType
        });
    },
    editUserTypeClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            userType = row.data();
        this.editUserType(userType);
    },
    editUserType: function (userType) {
        let fnEdit = _.bind(function (eut) {
            this.userTypeContext = eut;
            this.defaultColor = eut.get('color');
            this.dataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: eut.get('color'),
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', eut.get('color'));
        }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnEdit(newUserType);
            });
        } else {
            fnEdit(userType);
        }
    },
    editCompanyUserTypeClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row),
            userType = row.data();
        this.editCompanyUserType(userType);
    },
    editCompanyUserType: function (userType) {
        let fnEdit = _.bind(function (eut) {
            this.userTypeContext = eut;
            this.defaultColor = eut.get('color');
            this.companyDataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: eut.get('color'),
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', eut.get('color'));
        }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnEdit(newUserType);
            });
        } else {
            fnEdit(userType);
        }
    },
    deleteUserTypeClicked(e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        this.deleteUserType(row);
    },
    deleteUserType: function (row) {
        let userType = row.data(),
            fnDelete = _.bind(function (dut) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete User Type",
                    body: "Are you sure you want to delete this user type?  Any user who currently has this role will have to be changed to a new user type.",
                    onDelete: _.bind(function () {
                        let userHasType = false;
                        _.each(this.users.models, function (user) {
                            if (user.get('userTypeId') === userType.get('userTypeId')) {
                                userHasType = true;
                            }
                        });
                        if (userHasType) {
                            new PJQ.views.settings.ChangeUserTypeModal({
                                userTypeId: userType.get('userTypeId'),
                                title: userType.get('name') + " Users",
                                users: this.users,
                                onDelete: _.bind(function () {
                                    userType.destroy({
                                        success: _.bind(function () {
                                            this.collection.remove(dut);
                                            this.dataTable.removeRow(row);
                                            this.dataTable.refresh();
                                        }, this)
                                    });
                                }, this)
                            });
                        } else {
                            userType.destroy({
                                success: _.bind(function () {
                                    this.collection.remove(dut);
                                    this.dataTable.removeRow(row);
                                    this.dataTable.refresh();
                                }, this)
                            });
                        }
                    }, this)
                });
            }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnDelete(newUserType);
            });
        } else {
            fnDelete(userType);
        }
    },
    deleteCompanyUserTypeClicked(e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row);
        this.deleteCompanyUserType(row);
    },
    deleteCompanyUserType: function (row) {
        let userType = row.data(),
            fnDelete = _.bind(function (dut) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete User Type",
                    body: "Are you sure you want to delete this user type?  Any user who currently has this role will have to be changed to a new user type.",
                    onDelete: _.bind(function () {
                        let userHasType = false;
                        _.each(this.users.models, function (user) {
                            if (user.get('userTypeId') === userType.get('userTypeId')) {
                                userHasType = true;
                            }
                        });
                        if (userHasType) {
                            new PJQ.views.settings.ChangeUserTypeModal({
                                userTypeId: userType.get('userTypeId'),
                                title: userType.get('name') + " Users",
                                users: this.users,
                                onDelete: _.bind(function () {
                                    userType.destroy({
                                        success: _.bind(function () {
                                            this.collection.remove(dut);
                                            this.companyDataTable.removeRow(row);
                                            this.companyDataTable.refresh();
                                        }, this)
                                    });
                                }, this)
                            });
                        } else {
                            userType.destroy({
                                success: _.bind(function () {
                                    this.collection.remove(dut);
                                    this.companyDataTable.removeRow(row);
                                    this.companyDataTable.refresh();
                                }, this)
                            });
                        }
                    }, this)
                });
            }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnDelete(newUserType);
            });
        } else {
            fnDelete(userType);
        }
    },
    userTypeSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            userType = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-user-type-name');
        userType.set('name', $name.val());
        userType.set('sortOrder', userType.attributes.sortOrder);

        let isNameValid = _.size(userType.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            userType.save(null, {
                success: _.bind(function () {
                    this.userTypeContext = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    companyUserTypeSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            userType = this.companyDataTable.getRow($row).data(),
            $name = $row.find('.input-user-type-name');
        userType.set('name', $name.val());
        userType.set('sortOrder', userType.attributes.sortOrder);

        let isNameValid = _.size(userType.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            userType.save(null, {
                success: _.bind(function () {
                    this.userTypeContext = null;
                    this.companyDataTable.refresh();
                }, this)
            });
        }
    },
    cancelEditUserType: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            user = row.data();
        user.set('color', this.defaultColor);
        this.userTypeContext = null;
        this.userTypeColor = null;
        if (user.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.dataTable.refresh();
    },
    cancelEditCompanyUserType: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row),
            user = row.data();
        user.set('color', this.defaultColor);
        this.userTypeContext = null;
        this.userTypeColor = null;
        if (user.get('name').length === 0) {
            this.companyDataTable.removeRow(row);
        }
        this.companyDataTable.refresh();
    },
});

PJQ.views.settings.ChangeUserTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Change-User-Type'),
        title: "Change User Types",
        subtitle: "These Users Type must be changed before deleting."
    },
    events: {
        'click .btn-edit-user': 'editClicked',
        'click .user-type-change-done': 'checkDone'
    },
    beforeModalCreated: function () {
        this.users = this.options.users;
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".user-table"),
            isHideSearch: true,
            paginate: false,
            data: this.users.getByUserType(this.options.userTypeId),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            bSort: false,
            language: {
                zeroRecords: 'No more users have this type.  Hit done to complete deleting.'
            },
            rowCallback: function (row, data) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editUser(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "title": "User Type",
                    "data": "userType",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort' && row.userType !== undefined) {
                            return row.userType.get('sortOrder');
                        }
                        return '<span style="color:' + (row.userType !== undefined ? row.userType.get('color') : '#000000') + ';">' + (row.userType !== undefined ? row.userType.get('name') : "") + '</span>';
                    }, this)
                },
                {
                    "title": "Username",
                    "data": "attributes.username",
                },
                {
                    "title": "Name",
                    "data": "attributes.contactName",
                },
                {
                    "title": "Email",
                    "data": "attributes.email",
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '40px',
                    "render": _.bind(function (data, type, row) {
                        let button = '';
                        button += '<button type="button" class="btn btn-info btn-edit-user wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                        return '<div class="show-on-row-hover text-align-right">' + button + '</div>'
                    }, this)
                }
            ],
        });
        this.checkUsersLength()
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editUser(user);
    },
    editUser: function (user) {
        new PJQ.views.contacts.BaseEditContactModal({
            model: user,
            onSave: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.save(null, {
                        notify: true
                    });
                }
                this.dataTable.refresh();
                this.checkUsersLength()
            }, this),
            onClose: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                    this.checkUsersLength()
                }
            }, this),
            onDelete: _.bind(function (user) {
                let row = this.dataTable.getRow(user.cid);
                this.users.remove(user);
                if (row != null) {
                    this.dataTable.removeRow(row);
                }
                this.checkUsersLength()
            }, this)
        });
    },
    checkUsersLength: function () {
        if (this.users.getByUserType(this.options.userTypeId).length === 0) {
            this.$('.user-type-change-done').attr('disabled', false)
        }
    },
    checkDone: function () {
        if (this.users.getByUserType(this.options.userTypeId).length === 0) {
            this.options.onDelete;
            this.removeModal();
        }
    }
});

